import { useMemo } from 'react';
import { buildDotMenuScopeVisibility, isLimitedAdminScope } from '@/helpers';
import { useChurches, useGlobalSettings } from '@/hooks';

export const useDotMenuScopeVisibility = (): ((churchId: string) => boolean) | null => {
  const { currentChurch } = useGlobalSettings();
  const isLimitedScope = isLimitedAdminScope({
    isLimitedScope: currentChurch?.isLimitedScope,
    isGroupScope: currentChurch?.isGroupScope,
  });
  const { data: churches } = useChurches({
    churchId: currentChurch?.churchId,
    limit: 500,
    page: 1,
    enabled: !isLimitedScope,
  });

  return useMemo(() => {
    if (isLimitedScope) {
      return null;
    }

    const clusterItems = churches?.clusters?.flatMap((cluster) => cluster.items) ?? [];

    return buildDotMenuScopeVisibility({ clusterItems });
  }, [churches?.clusters, isLimitedScope]);
};
